const notes = [
    {
      key: 1,
      title: "Beautiful Downtown Cleveland Condo - Toronto",
      content: "3 guests · 2 bedrooms · 2 beds · 2 baths",
      image: "https://www.homestratosphere.com/wp-content/uploads/2019/02/decor-aid-hamptons-feb19-00008-min.png",
      price: "210.00"
    },
    {
      key: 2,
      title: "The Grey Barn Suite - Hamilton",
      content: "Entire 2-bedroom, 2-bath condo is available to the guest",
      image: "https://hips.hearstapps.com/hbu.h-cdn.co/assets/cm/15/04/54c4957687501_-_20-hbx-northern-california-cottage-0613-xln-94572308.jpg",
      price: "180.00"
    },
    {
      key: 3,
      title: "Safe and Clean Cozy Waterfront Cottage - Toronto",
      content: "5 guests · 2 bedroom · 5 bed · 2 bath",
      image: "https://i.pinimg.com/736x/c4/e0/9f/c4e09faee7f7653a76d940f5d36a7d7c.jpg",
      price: "120.00"
    },
    {
      key: 4,
      title: "Freesh air house - Vancouver",
      content: "5 guests · 3 bedroom · 3 bed · 2 bath",
      image: "https://i.pinimg.com/originals/cd/72/38/cd72387f90ce5dfd83af6fad7ac75338.jpg",
      price: "270.00"
    },
    {
      key: 5,
      title: "Modern House impressive - Ottawa",
      content: "5 guests · 3 bedroom · 3 bed · 2 bath",
      image: "https://photos.zolo.ca/164-bristol-crescent-ottawa-1354563-1.jpg",
      price: "198.00"
    },
    {
      key: 5,
      title: "Beach House Beauty - Vancouver",
      content: "8 guests · 6 bedroom · 13 bed · 3 bath",
      image: "https://www.impressiveinteriordesign.com/wp-content/uploads/2015/01/Pictures-Of-Beach-House-Architecture-And-Their-Beautiful-Surroundings-9.jpg",
      price: "245.00"
    },
    {
      key: 6,
      title: "Amazin House - Ottawa",
      content: "6 guests · 3 bedroom · 2 bed · 1 bath",
      image: "https://www.cardelhomes.com/wp-content/uploads/2020/03/cardel-homes-ottawa-blackstone-devonshire-model-home-02.jpg",
      price: "190.00"
    },
    {
      key: 7,
      title: "Luxury House - Toronto",
      content: "12 guests · 6 bedroom · 12 bed · 4 bath",
      image: "http://d2kcmk0r62r1qk.cloudfront.net/imageSponsors/xlarge/2021_02_03_06_53_54_lot1-final-rev2-scaled.jpg",
      price: "390.00"
    },
    {
      key: 8,
      title: "Luxury Mansion - Vancouver",
      content: "25 guests · 12 bedroom · 12 bed · 6 bath",
      image: "https://s.hdnux.com/photos/01/10/13/01/18919515/3/rawImage.jpg",
      price: "590.00"
    }
  ];
  
  export default notes;
  